<template>
  <v-row>
    <v-col sm="12">
      <v-card outlined>
        <v-card-title>Material Description</v-card-title>
        <blockquote class="blockquote">{{ material.notes }}</blockquote>
      </v-card>
    </v-col>
    <v-col md="6" sm="12">
      <v-card outlined>
        <v-card-title>Properties</v-card-title>
        <v-list>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="indigo darken-1">
                {{ material.surfaceareaIcon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ material.surfacearea }}
              </v-list-item-title>
              <v-list-item-subtitle>Surface Area</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="indigo darken-2">
                {{ material.bulkdensityIcon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ material.bulkdensity }}
              </v-list-item-title>
              <v-list-item-subtitle>Bulk Density</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="indigo darken-3">
                {{ material.sizeIcon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ material.size }}
              </v-list-item-title>
              <v-list-item-subtitle>Size</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="indigo darken-4">
                {{ material.moistureIcon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ material.moisture }}
              </v-list-item-title>
              <v-list-item-subtitle>Moisture</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-col>
    <v-col md="6" sm="12">
      <v-card outlined>
        <v-card-title>Sourcing</v-card-title>
        <v-list>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="indigo darken-1">
                {{ material.powder.icon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ material.powder.name }}
              </v-list-item-title>
              <v-list-item-subtitle>Powder Type</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <PowderFormEdit :instance="material.powder"/>
            </v-list-item-action>
          </v-list-item>
          <v-divider/>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="indigo darken-2">
                {{ material.supplier.icon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ material.supplier.name }}
              </v-list-item-title>
              <v-list-item-subtitle>Supplier</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <SupplierFormEdit
                :instance="material.supplier"
              />
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="indigo darken-3">
                {{ material.manufacturer.icon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ material.manufacturer.name }}
              </v-list-item-title>
              <v-list-item-subtitle>Manufacturer</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <ManufacturerFormEdit
                :instance="material.manufacturer"
              />
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ManufacturerFormEdit from "../../components/Material/ManufacturerFormEdit";
import SupplierFormEdit from "../../components/Material/SupplierFormEdit";
import PowderFormEdit from "../../components/Material/PowderFormEdit";
export default {
  name: "MaterialSummary",
  components: {
    ManufacturerFormEdit,
    SupplierFormEdit,
    PowderFormEdit
  },
  props: {
    material: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
};
</script>
